import React from 'react';
import MendozaPageHardcoded from './MendozaPageHardcoded';
import './MendozaPage.css';

const MendozaPage: React.FC = () => {
  // Using hardcoded version with approved wine country content
  return <MendozaPageHardcoded />;
};

export default MendozaPage;